<template>
  <div>
    <div class="va-row">
      <div class="flex md5 xs12">
        <h4>Questions you may have</h4>
        <button
          v-for="article in articles"
          :key="article.id"
          @click="$emit('view-article', article.id)"
          class="btn btn-primary btn-micro btn-block rounded faq-btn"
        >
          {{ article.title }}
        </button>
      </div>
      <div class="flex md6 offset-md-1 xs12 text-center">
        <div class="faq-image_container">
          <img
            :src="require('@/assets/images/go-faq.png')"
            alt="INNO SUPPORT FAQ"
          />
        </div>
      </div>
    </div>
    <hr />
    <h3>Topics</h3>
    <div class="va-row">
      <div class="flex md6">
        <div class="faq-image-container">
          <img
            :src="require('@/assets/images/softphone-config.svg')"
            alt="SOFTPHONE CONFIG"
          />
          <h4 class="text-muted">Softphone Configuration</h4>
        </div>
        <ul>
          <li v-for="article in articles" :key="article.id">
            <a class="text-primary" @click="$emit('view-article', article.id)">
              {{ article.title }}
            </a>
          </li>
        </ul>
      </div>
      <div class="flex md6">
        <div class="faq-image-container">
          <img
            :src="require('@/assets/images/admin-interface.svg')"
            alt="SOFTPHONE CONFIG"
          />
          <h4 class="text-muted">Administration Interface</h4>
        </div>
        <ul>
          <li v-for="article in articles" :key="article.id">
            <a class="text-primary" @click="$emit('view-article', article.id)">
              {{ article.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Topics',
  props: ['articles']
}
</script>

<style lang="scss" scoped>
.faq-image_container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.faq-image-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: max-content;
  img {
    max-height: 120px;
    width: max-content;
    margin: 0 auto;
  }
}
.faq-btn {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
  text-align: left;
  font-weight: 600;
  &:hover {
    white-space: unset;
    overflow: unset;
    text-overflow: unset;
  }
}
</style>
